"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.hasAnyOf = exports.hasAllProperties = void 0;
exports.isEmptyObject = isEmptyObject;
exports.roughSizeOfObject = roughSizeOfObject;
function isEmptyObject(obj) {
    const keys = Object.keys(obj);
    return keys.length === 0;
}
function roughSizeOfObject(object) {
    const objectList = [];
    const stack = [object];
    let bytes = 0;
    while (stack.length) {
        const value = stack.pop();
        if (typeof value === 'boolean') {
            bytes += 4;
        }
        else if (typeof value === 'string') {
            bytes += value.length * 2;
        }
        else if (typeof value === 'number') {
            bytes += 8;
        }
        else if (typeof value === 'object'
            && objectList.indexOf(value) === -1) {
            objectList.push(value);
            for (const i in value) {
                stack.push(value[i]);
            }
        }
    }
    return bytes;
}
const hasAllProperties = (obj, ...keys) => keys.every(key => obj[key] !== null && obj[key] !== undefined);
exports.hasAllProperties = hasAllProperties;
const hasAnyOf = (obj, ...keys) => keys.some(key => obj[key] !== null && obj[key] !== undefined);
exports.hasAnyOf = hasAnyOf;
